class CarClear extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (e) => {
      e.preventDefault();
      this.clearCart();
    });
  }

  clearCart = () => {
    fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Failed to clear cart');
      }
      return response.json();
    })
    .then(data => {
      window.location.href = '/collections/inele-cu-diamante-certificate';
      // Cart cleared successfully, handle any additional logic here
      console.log('Cart cleared:', data);
    })
    .catch(error => {
      console.error('Error clearing cart:', error);
    });
  };
}

customElements.define('cart-clear', CarClear);